export default {
  props: {},
  data: function () {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
};
